import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { connect } from 'react-redux';
import { hasFeature } from './hasFeature';
function mapStateToProps(state, ownProps) {
    return {
        hasFeature: hasFeature(state, ownProps.name),
    };
}
/** Render a component if the provided feature flag is enabled */
function IfFeatureFlagOnInner(props) {
    return props.hasFeature ? _jsx(_Fragment, { children: props.children }) : null;
}
/** Render a component if the provided feature flag is disabled */
function IfFeatureFlagOffInner(props) {
    return !props.hasFeature ? _jsx(_Fragment, { children: props.children }) : null;
}
/** @deprecated Use `useFeatureFlag` instead. */
export const IfFeatureFlagOn = connect(mapStateToProps)(IfFeatureFlagOnInner);
/** @deprecated Use `useFeatureFlag` instead. */
export const IfFeatureFlagOff = connect(mapStateToProps)(IfFeatureFlagOffInner);
